type Props = {
    color?: string;
    width?: number;
    height?: number;
};

export default function IconWarningFilledColor({ width = 22, height = 22 }: Props) {
    return (
        <svg width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.17908 24.5C2.9652 24.5 2.77075 24.4465 2.59575 24.3396C2.42075 24.2326 2.28464 24.0917 2.18742 23.9167C2.0902 23.7417 2.03672 23.5521 2.027 23.3479C2.01728 23.1438 2.07075 22.9444 2.18742 22.75L12.9791 4.08333C13.0957 3.88889 13.2464 3.74306 13.4312 3.64583C13.6159 3.54861 13.8055 3.5 13.9999 3.5C14.1944 3.5 14.3839 3.54861 14.5687 3.64583C14.7534 3.74306 14.9041 3.88889 15.0208 4.08333L25.8124 22.75C25.9291 22.9444 25.9826 23.1438 25.9728 23.3479C25.9631 23.5521 25.9096 23.7417 25.8124 23.9167C25.7152 24.0917 25.5791 24.2326 25.4041 24.3396C25.2291 24.4465 25.0346 24.5 24.8207 24.5H3.17908Z"
                fill="#F05687"
            />
            <path
                d="M14.8314 20.6649C14.6078 20.8885 14.3307 21.0003 14.0002 21.0003C13.6696 21.0003 13.3925 20.8885 13.1689 20.6649C12.9453 20.4413 12.8335 20.1642 12.8335 19.8337C12.8335 19.5031 12.9453 19.226 13.1689 19.0024C13.3925 18.7788 13.6696 18.667 14.0002 18.667C14.3307 18.667 14.6078 18.7788 14.8314 19.0024C15.055 19.226 15.1668 19.5031 15.1668 19.8337C15.1668 20.1642 15.055 20.4413 14.8314 20.6649Z"
                fill="white"
            />
            <path
                d="M14.8314 17.1649C14.6078 17.3885 14.3307 17.5003 14.0002 17.5003C13.6696 17.5003 13.3925 17.3885 13.1689 17.1649C12.9453 16.9413 12.8335 16.6642 12.8335 16.3337V12.8337C12.8335 12.5031 12.9453 12.226 13.1689 12.0024C13.3925 11.7788 13.6696 11.667 14.0002 11.667C14.3307 11.667 14.6078 11.7788 14.8314 12.0024C15.055 12.226 15.1668 12.5031 15.1668 12.8337V16.3337C15.1668 16.6642 15.055 16.9413 14.8314 17.1649Z"
                fill="white"
            />
        </svg>
    );
}
